import { useDropzone } from "react-dropzone";
import styled, { css } from "styled-components";
import { Box, Stack, Text } from "@aksara-ui/react";
import React, { useEffect } from "react";
import { ReactComponent as DropzoneImg } from "assets/images/icons/bulk-training-upload-icon.svg";

const Container = styled(Box)`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  border-width: 2px;
  border-radius: 2px;
  border-color: #eeeeee;
  border-style: dashed;
  background-color: #fafafa;
  color: #bdbdbd;
  outline: none;
  transition: border 0.24s ease-in-out;
`;

const Preview = styled(Box)`
  display: flex;
  flexdirection: row;
  flexwrap: wrap;
`;

const ThumbInner = styled(Box)`
  display: flex;
  minwidth: 0;
  overflow: hidden;
`;

const Image = styled.img`
  borderradius: 10;
  display: block;
  width: 100%;
  height: auto;
`;

const Hero = css`
  width: 80px;
  height: inherit;
`;

const DropzoneIcon = styled(DropzoneImg)`
  ${Hero}
`;

type FilesProps = {
  files: any;
  setFiles: any;
  name?: string;
};

const ImageDropzone: React.FC<FilesProps> = ({ files, setFiles, name }) => {
  const { getRootProps, getInputProps } = useDropzone({
    accept: {
      "image/*": [],
    },
    onDrop: (acceptedFiles: any) => {
      setFiles(
        acceptedFiles.map((file: any) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          })
        )
      );
    },
  });

  const thumbs = files.map((file: any) => (
    <Box
      style={{
        display: "inline-flex",
        borderRadius: 10,
        border: "0.5px solid #eaeaea",
        marginRight: 8,
        width: "auto",
        height: 100,
        padding: 2,
        boxSizing: "border-box",
      }}
      key={!file.name ? file : file.name}
    >
      <ThumbInner>
        <Image
          src={!file.preview ? file : file.preview}
          onLoad={() => {
            URL.revokeObjectURL(file.preview);
          }}
          alt="img-preview"
        />
      </ThumbInner>
    </Box>
  ));

  useEffect(() => {
    return () =>
      files.forEach((file: any) => URL.revokeObjectURL(file.preview));
  }, [files]);

  return (
    <Box className="container">
      <Container {...getRootProps({ className: "dropzone" })}>
        <input {...getInputProps(name ? { name } : {})} />

        {!files.length ? (
          <Stack
            display="flex"
            flexDirection="column"
            alignItems="center"
            style={{ gap: 10 }}
          >
            <DropzoneIcon />
            <Text>Drop some files here or select files</Text>
          </Stack>
        ) : (
          <Preview>{thumbs}</Preview>
        )}
      </Container>
    </Box>
  );
};

export default ImageDropzone;
